<template>
    <div>
        <footer>
            <div class="container-fluid legal-info">
                <div class="container">
                    <div class="row">
                        <div class="col d-flex pt-3 pb-3">
                            <div>Viajes Cemo - EspecialVacaciones</div>
                            <div class="ml-auto">
                                <router-link to="/condiciones-generales" class="pr-3">Condiciones Generales</router-link>
                                <router-link to="/politica" class="pr-3">Política de Privacidad</router-link>
                                <router-link to="/cookies" class="pr-3">Cookies</router-link>
                                <router-link to="/avisolegal" class="pr-3">Aviso Legal</router-link>
                                <router-link to="/contacto" class="pr-3">Contacto</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

export default {
    name: 'AppFooter',
    components: {

    },
    data: () => ({
        titulo: 'Footer Aplicacion',

    }),
    methods: {

    },

}
</script>
